<template>
  <div class="relative" @click="focus()">
    <VField :name="name" v-slot="{ field, meta, errors }">
      <textarea
        ref="textarea"
        v-bind="field"
        :placeholder="label"
        :type="name"
        :class="{
          ' border  bg-secondary/20': !meta.valid && meta.touched,
        }"
        class="base-textarea peer placeholder-transparent h-36"
      ></textarea>
      <label class="base-textarea-label">
        {{ label }}
      </label>
      <VErrorMessage
        :name="name"
        as="div"
        class="md:mt-1 -mt-2 text-xs text-red-500 px-2"
      />
      <div class="debug" v-if="debug">
        <pre>{{ errors }}</pre>
        <pre>{{ meta }}</pre>
      </div>
    </VField>
  </div>
</template>

<script setup>
const textarea = ref("");
defineProps({
  name: String,
  inputClass: {
    type: String,
    default: "",
  },
  debug: {
    type: Boolean,
    default: false,
  },
  placeholder: String,
  label: String,
});
const focus = () => {
  textarea.value.focus();
};
</script>
